// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3BStd","left":"styles_left__1JUjr"};